import { useEffect, useCallback, useState } from "react";
import { fetchAllVehicles, fetchAvailableVehicles } from "../services/dashboard";

export const useVehicles = (opts?: { availableOnly?: boolean; branchId?: string; branchLocation?: string }) => {
  const [vehicles, setVehicles] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchVehicles = useCallback(async () => {
    setLoading(true);
    try {
      const res = opts?.availableOnly
        ? await fetchAvailableVehicles(0, 1000, opts?.branchLocation, opts?.branchId)
        : await fetchAllVehicles(0, 50, opts?.branchLocation, opts?.branchId);
      setVehicles(res.data?.vehicles || []);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }, [opts?.availableOnly, opts?.branchId, opts?.branchLocation]);

  useEffect(() => {
    fetchVehicles();
  }, [fetchVehicles]);

  return { vehicles, loading, fetchVehicles };
};
